export default {
    move_to_other_account_title: "Mover a otra cuenta",
    move_to_other_account_account_from: "Account Origen",
    move_to_other_account_account_to: "Account Destino",
    move_to_other_account_devices: "Dispositivos",
    move_to_other_account_input: "IMEI o serie",
    move_to_other_account_imei: "IMEI",
    move_to_other_account_serial: "Serie",
    move_to_other_account_model: "Modelo",
    move_to_other_account_change: "Mover",
    move_to_other_account_no_devices_added: "No se han añadido dispositivos",
    move_to_other_account_device_is_already_added: "El dispositivo ya está añadido",
    move_to_other_account_device_has_not_been_found: "No se ha encontrado el dispositivo",
    move_to_other_account_this_feature_is_not_available: "Esta función no está disponible",
    move_to_other_account_single_success_message: "se ha movido el dispositivo",
    move_to_other_account_multiple_success_message: "Se han movido los dispositivos",
    move_to_other_account_error_message: "No se pueden mover los devices debido a un error",
    move_to_other_account_select_to_account: "Seleccione la cuenta de destino primero",
    move_to_other_account_restriction_to_move: "No se pueden mover dispositivos activos a cuentas que no están activas",
    move_to_other_account_transaction_message: "La solicitud para mover los dispositivos ha sido enviada con éxito, por favor revise la lista de transacciones para ver el estado de la solicitud.",
}